import(/* webpackMode: "eager" */ "/app/apps/web/src/app/friends/page.tsx");
